module.exports = __webpack_public_path__ + "fonts/feather_icon.66cbb621.woff";